import React, { useEffect, useState, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import CircularLoadingPopUp from '../components/CircularLoadingPopUp';
import { getErrorMessage } from "../utils/error";
import { getOpenScanPdf } from "../utils/api";

const ScanResult = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const scanId = searchParams.get('scan_id');
    const subScanId = searchParams.get('sub_scan_id');
    const isProtected = searchParams.get('protected') === 'true';
    const companyId = searchParams.get('company_id');
    const [errorMsg, setErrorMsg] = useState("");
    const [loadingPDF, setLoadingPDF] = useState(false);
    const hasFetched = useRef(false);

    useEffect(() => {
        if (hasFetched.current) return;
        hasFetched.current = true;

        if (isProtected) {
            const alreadySet = localStorage.getItem("redirectAfterLogin");
            if (!alreadySet) {
                localStorage.setItem('redirectAfterLogin', window.location.pathname + window.location.search);
            }
            navigate('/');
        } else {
            fetchPDF();
        }
    }, []);

    const fetchPDF = async () => {
        try {
            setLoadingPDF(true);
            const res = await getOpenScanPdf(scanId, subScanId, companyId);
            if (res?.status === 404) {
                setErrorMsg(
                    "The Scan ID you’re trying to access doesn’t exist in the cloud. Please sync your data to the cloud. After syncing, you’ll be able to open this link."
                );
            }
            const downloadUrl = URL.createObjectURL(res.data);
            window.open(downloadUrl)
        } catch (error) {
            console.error(error);
            const message = getErrorMessage(error);
        } finally {
            setLoadingPDF(false);
        }
    };

    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
            {loadingPDF && <CircularLoadingPopUp />}
            {errorMsg && (
                <div
                    style={{
                        maxWidth: "600px",
                        textAlign: "center",
                        fontWeight: "bold",
                        fontSize: "20px",
                        color: "rgb(34, 93, 153)",
                        padding: "20px",
                    }}
                >
                    {errorMsg}
                </div>
            )}
        </div>
    );

};

export default ScanResult;
